import { render, staticRenderFns } from "./VSelectMedicationDci.vue?vue&type=template&id=5106777c"
import script from "./VSelectMedicationDci.vue?vue&type=script&lang=js"
export * from "./VSelectMedicationDci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports